import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import FirmwareAdminSettings from 'components/admin/washboard/FirmwareAdminSettings';
import Tabs from 'components/common/tabsTable/TabsTable';
import './FirmwareManager.scss';
import FirmwareManagerTable from './FirmwareManagerTable';

export const FIRMWARE_RELEASES_PATH = '/firmware';
export const FIRMWARE_ADMIN_SETTINGS_PATH = '/firmware/admin-settings';

const TAB_PATHS = [FIRMWARE_RELEASES_PATH, FIRMWARE_ADMIN_SETTINGS_PATH];

const FirmwareManager: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabValueSelected = Math.max(TAB_PATHS.indexOf(pathname), 0);

  const tabsData = useMemo(
    () => [
      { name: 'Releases', value: 'releases', children: <FirmwareManagerTable /> },
      { name: 'Global Settings', value: 'global-settings', children: <FirmwareAdminSettings /> },
    ],
    [],
  );

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    history.push(TAB_PATHS[newValue]);
  };

  return (
    <div className="page-container firmware-manager-page">
      <div className="washboard-header">
        <h1>Firmware manager</h1>
      </div>

      <Tabs
        tabsData={tabsData}
        tabValueSelected={tabValueSelected}
        handleTabChange={handleTabChange}
      />
    </div>
  );
};

export default FirmwareManager;
